export default "__VITE_ASSET__60490351__"